import React from 'react';
import { Box, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

import useQuestion from './useQuestion';

const useStyles = makeStyles(() => ({
    mulitLineText: {
        '& .MuiInputBase-multiline': {
            borderRadius: '8px',
        },
    },
    readOnly: {
        '& .MuiInputBase-multiline.Mui-disabled': {
            backgroundColor: '#EFEFEF',
            outline: 'none',
            border: '1px solid #EFEFEF',
            opacity: 1,
            '& .MuiOutlinedInput-input.Mui-disabled': {
                '-webkit-text-fill-color': 'unset',
                color: '#586874',
                fontSize: '15px',
            },
        },
    },
}));

const MultiLineText = (props) => {
    const { question, disabled, readOnly } = props;

    const { answerText } = useQuestion(question);

    const classes = useStyles();

    //#TODO TechDebt - This Component has only had a readOnly state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <Box>
            <TextField
                size="small"
                multiline
                rows={7}
                sx={{ width: 400 }}
                className={classNames({
                    [classes.mulitLineText]: true,
                    [classes.readOnly]: readOnly,
                })}
                disabled={disabled || readOnly}
                value={answerText}
            />
        </Box>
    );
};

export default MultiLineText;
